/* FW 2026-09-19 — video governor.

   The PDP carries seven autoplaying <video> elements: two in the media grid, four
   in community reviews, one in the flow-state section. Each section runs its own
   IntersectionObserver with a 250-300px rootMargin, plays on enter and only pauses
   on exit — so on a desktop scroll five or six can be decoding simultaneously.
   Browsers cap concurrent video decoders and the surplus stalls on a frame rather
   than erroring, which is the "videos freeze after a minute" report.

   This file caps how many play at once and pauses anything fully off screen.

   Two deliberate constraints:
   - It only pauses videos, and only resumes ones IT paused (marked data-fw-gov).
     Sections keep full control of when a video first starts, so there is nothing
     to fight and no autoplay-policy rejections to swallow.
   - Anything the visitor has taken control of — native controls showing, the
     community-reviews cr-active class, or simply unmuted — is skipped entirely.
     Their tap always wins.
*/
(function () {
  if (window.__fwVideoGovernor) return;
  window.__fwVideoGovernor = true;

  /* Four on desktop lets the community-reviews row animate in full while the media
     grid and flow-state videos sit paused; two on a phone, where the decoder budget
     is much smaller and only one card is on screen anyway. */
  var MAX = window.matchMedia('(min-width: 940px)').matches ? 4 : 2;

  function userOwned(v) {
    return v.hasAttribute('controls') || v.classList.contains('cr-active') || !v.muted;
  }

  /* null = not on screen at all. Otherwise: distance from the viewport's centre,
     so the videos a visitor is actually looking at are the ones that keep playing. */
  function distanceFromCentre(v) {
    var r = v.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.bottom <= 0 || r.top >= vh || r.width < 2 || r.height < 2) return null;
    return Math.abs((r.top + r.bottom) / 2 - vh / 2);
  }

  function pause(v) {
    if (v.paused) return;
    v.dataset.fwGov = '1';
    v.pause();
  }

  function resume(v) {
    if (!v.paused || v.dataset.fwGov !== '1') return;
    v.dataset.fwGov = '';
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function govern() {
    var vids = [].slice.call(document.querySelectorAll('video'));
    if (!vids.length) return;

    /* A backgrounded tab still holds its decoders. Release them. */
    if (document.visibilityState === 'hidden') {
      vids.forEach(function (v) { if (!userOwned(v)) pause(v); });
      return;
    }

    var onScreen = [];
    vids.forEach(function (v) {
      if (userOwned(v)) return;
      var d = distanceFromCentre(v);
      if (d === null) { pause(v); return; }
      onScreen.push({ v: v, d: d });
    });

    onScreen.sort(function (a, b) { return a.d - b.d; });
    onScreen.forEach(function (item, i) {
      if (i < MAX) resume(item.v); else pause(item.v);
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; govern(); });
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('visibilitychange', govern);

  /* Sections start videos from their own observers, which can fire without a scroll
     event (lazy sources finishing, the theme editor re-rendering a section). One
     cheap sweep a second catches those. */
  setInterval(govern, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', govern);
  } else {
    govern();
  }
})();
